module.exports = __webpack_public_path__ + "media/iconic/plus-8d8c97c6.svg";